import { useOpMutation } from '../useOpMutation';

export const useDetermineLoginCandidateNamespaces = () =>
  useOpMutation({
    apiEndpointName: 'determineLoginCandidateNamespaces',
  });
